import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(
  ({ palette, typography, spacing, breakpoints, props }) => ({
    root: {
      transition: 'filter 0.2s',
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      '&:hover': {
        filter: 'drop-shadow(0px 10px 10px #CCC9CF)'
      }
    },
    card: {
      display: 'flex',
      width: '100%',
      height: '100%'
    },
    header: {
      maxWidth: '100%',
      marginBottom: spacing(1)
    },
    info: {
      color: palette.text.secondary,
      fontWeight: typography.fontWeightMedium,
      '& svg': {
        marginRight: spacing(0.5)
      }
    },
    time: {
      color: palette.primary.main,
      fontWeight: typography.fontWeightBold
    },
    actions: {
      marginTop: props => props.fullWidth ? 0 : spacing(3),
      marginBottom: spacing(2)
    }
  })
)
